<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="产品名称">
          <el-input placeholder="请输入产品名称" v-model="formInline.search">

          </el-input>

        </el-form-item>
               <!-- <el-form-item label="企业id">
          <el-input placeholder="请输入企业id" v-model="formInline.supply_id">

          </el-input>

        </el-form-item> -->
        <el-form-item >
           <el-button size="small" type="info" v-if="supply_id > 0" @click="cancelFunc">返回上一页</el-button>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>

      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加产品</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">

            <el-table-column prop="supply_product_id" label="序号"></el-table-column>
            <el-table-column prop="name" label="产品名称"></el-table-column>
            <el-table-column prop="sku" label="sku编号"></el-table-column>
            <el-table-column prop="status" label="启用">
              <template slot-scope="scope">
                <el-switch
                  @change="setStatus(scope.row)"
                  v-model="scope.row.status"
                  active-color="#13ce66"
                  inactive-color="#c0c4cc"
                  :active-value="1"
                  :inactive-value="0"
                >
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="sort" label="排序" ></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
             <el-table-column fixed="right" label="操作" width="180">
                            <template slot-scope="scope">
                                <div class="action-buttons">
                                    <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                                    <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
                                </div>
                            </template>
                        </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add :open_add="open_add" :supply_id="supply_id" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :supply_id="supply_id" :supply_product_id="supply_product_id"  v-if="open_edit"   @close="closeEdit"></Edit>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible'
    :close-on-click-modal="false"
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>

  </div>
</template>

<script>
import SupplyApi from '@/api/supply.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:""
        },

        open_add:false,
        open_edit:false,
        supply_product_id:"",
        dialogVisible:false,
      };
    },
    created() {
      this.supply_id =  this.$route.query.supply_id;
      this.formInline.supply_id = this.$route.query.supply_id;
      /*获取列表*/
      this.getTableList();
    },
    methods: {
      setStatus(item) {
        let self = this;
        const originalStatus = item.status;
        const isOpen = item.status === 1;
        const confirmText = isOpen ? '确认上架吗？' : '确认下架吗？';

        self.$confirm(confirmText, '操作确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          let form = {
            'supply_product_id': item.supply_product_id,
            'status': item.status,
          };
          SupplyApi.saveStatus(form, true)
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                const successText = isOpen ? '上架成功' : '下架成功';
                self.$message({ message: successText, type: 'success' });
                self.getTableList();
              } else {
                self.loading = false;
                item.status = originalStatus;
                self.$message.error('操作失败，请重试');
              }
            })
            .catch(error => {
              self.loading = false;
              item.status = originalStatus;
              self.$message.error('操作失败，请重试');
            });
        }).catch(() => {
          // 关键修复：用$nextTick确保视图同步还原
          this.$nextTick(() => {
            // item.status = originalStatus;
            this.getTableList();
            const cancelText = isOpen ? '已取消开启操作' : '已取消禁用操作';
            self.$message({ type: 'info', message: cancelText });
          });
        });
      },
             /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      },
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//协会标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },
       getStatusText(status) {
                    const statusMap = {
                        0: '未审核',
                        1: '已通过',
                        2: '已拒绝'
                    };
                    return statusMap[status] || '未知';
                },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        SupplyApi.productlist(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑产品*/
      editClick(row) {
        this.supply_product_id = row.supply_product_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            SupplyApi.delproduct(
              {
                supply_product_id: row.supply_product_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/supply/product/index.vue